import type React from 'react';

import { Avatar, Text } from '@change/ds-core-ui';

import type { TeamMember } from '#src/app/pages/about/team/pageContext';

import { useTeamMemberCard } from './hooks/useTeamMemberCard';

const avatarProps = { loading: 'lazy' as const };

export const TeamMemberCard: React.FC<{ member: TeamMember }> = ({ member }) => {
	const {
		data: { photoUrl },
	} = useTeamMemberCard(member);

	return (
		<li className="flex flex-col items-center justify-center">
			{/** Mobile: Since we are not able to add different sizes for avatars, we are using multiple Avatar components with different sizes */}
			<div className="block md:hidden">
				<Avatar size={140} src={photoUrl} alt="" {...avatarProps} />
			</div>
			{/** Tablet: Since we are not able to add different sizes for avatars, we are using multiple Avatar components with different sizes */}
			<div className="hidden md:block lg:hidden">
				<Avatar size={160} src={photoUrl} alt="" {...avatarProps} />
			</div>
			{/** Desktop: Since we are not able to add different sizes for avatars, we are using multiple Avatar components with different sizes */}
			<div className="hidden lg:block">
				<Avatar size={180} src={photoUrl} alt="" {...avatarProps} />
			</div>
			<div>
				<Text as="h3" variant="heading" size="x-small" className="mt-6 text-center">
					{member.displayName}
				</Text>
				<Text as="p" size="small" className="text-center">
					{member.title}
				</Text>
			</div>
		</li>
	);
};
